<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-hover">
      <thead>
        <tr>
          <th class="text-lefth">#</th>
          <th class="text-lefth">Tienda</th>
          <th class="text-lefth">Usuario</th>
          <th class="text-lefth">Creado Hace</th>
          <th class="text-center">Fecha</th>
          <th class="text-lefth">Proveedor</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="
            irAEsconderModal('compras-ordencompra-editar', {
              id: current.id,
            })
          "
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td class="text-lefth">
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td class="text-center">
            {{ current.fecha_creacion | moment("DD/MM/YYYY") }}
          </td>
          <td class="text-lefth">
            {{ current.proveedor.nombre }}
          </td>
          <td class="text-center" v-if='current.estado_str  == "Abierto"'>
            <span class="badge badge-sm badge-success">{{ current.estado_str }}</span>
          </td>
          <td class="text-center" v-if='current.estado_str  == "Cerrado"'>
            <span class="badge badge-sm badge-warning">{{ current.estado_str }}</span>
          </td>
          <td class="text-center" v-if='current.estado_str  == "Anulado"'>
            <span class="badge badge-sm badge-danger">{{ current.estado_str }}</span>
          </td>
          <td class="text-center" v-if='current.estado_str  == "De Baja"'>
            <span class="badge badge-sm badge-secondary">{{ current.estado_str }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import OrdenCompraService from "@/services/compras/OrdenCompraService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "ordencompra/orden_compras",
    }),
  },
  mounted() {},
  methods: {
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      
    },
    generar_entrada_compra(current) {
      /**
       * Genera una entrada de inventario basada en la orden de compra
       */
      let self = this;
      OrdenCompraService.generar_entrada_compra(current.id)
        .then((response) => {
          Notifications.alert.confirm(
            "Entrada de prodcuto",
            "Ir a la Entrada Generada",
            "",
            function () {
              self.$router.push({
                name: "",
                params: { id: response.data.ent_compra },
              });
            }
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
